import { render, staticRenderFns } from "./FundList.vue?vue&type=template&id=2ed774b6&scoped=true&"
import script from "./FundList.vue?vue&type=script&lang=js&"
export * from "./FundList.vue?vue&type=script&lang=js&"
import style0 from "./FundList.vue?vue&type=style&index=0&id=2ed774b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed774b6",
  null
  
)

export default component.exports